import React from 'react';
import PropTypes from 'prop-types';
import { translate } from '@utils/i18n';
import OverflowActionsMenu from '@components/OverflowActionsMenu';
import UpdateStatusesModal from './UpdateStatusesModal';
import ExportCsv from './ExportCsv';
import PublishToCustomerPortal from './PublishToCustomerPortal';

const namespace = 'features.work_orders.index.mass_actions';

function MassActions({
  state,
  onSelectAll,
  queryParams,
  onDataChanged,
  workOrderStatusesForSelect,
  hasShowAllServiceReportsInCustomerPortal
}) {
  const { data: workOrders, selectAll, totalCount } = state;
  const selectedWorkOrders = workOrders.filter((workOrder) => workOrder.selected);
  const disabled = selectedWorkOrders.length === 0;
  const workOrdersCount = selectAll ? totalCount : selectedWorkOrders.length;
  const workOrderIds = selectedWorkOrders.map((workOrder) => workOrder.id).join();

  return (
    <div className="qmb-actions">
      {!disabled && (
        <div className="actions__group--selection">
          <button type="button" className="actions__selection">
            <span className="actions__count">{workOrdersCount}</span>
          </button>
          {!selectAll && (
            <div className="actions__entire">
              <button type="button" tabIndex="0" className="qmb-control--sm" onClick={onSelectAll}>
                {translate('selected_global_counter', { namespace, count: totalCount })}
              </button>
            </div>
          )}
        </div>
      )}

      <OverflowActionsMenu className="actions__group" disabled={disabled}>
        <UpdateStatusesModal
          workOrdersCount={workOrdersCount}
          workOrderIds={!selectAll && workOrderIds}
          disabled={disabled}
          workOrderStatusesForSelect={workOrderStatusesForSelect}
          queryParams={queryParams}
          onDataChanged={onDataChanged}
        />
        <ExportCsv disabled={disabled} workOrderIds={!selectAll && workOrderIds} queryParams={queryParams} />
        {!hasShowAllServiceReportsInCustomerPortal && (
          <PublishToCustomerPortal
            workOrdersCount={workOrdersCount}
            workOrderIds={!selectAll && workOrderIds}
            disabled={disabled}
            queryParams={queryParams}
          />
        )}
      </OverflowActionsMenu>
    </div>
  );
}

MassActions.propTypes = {
  state: PropTypes.shape({
    data: PropTypes.arrayOf(PropTypes.object),
    totalCount: PropTypes.number,
    selectAll: PropTypes.bool
  }).isRequired,
  onSelectAll: PropTypes.func.isRequired,
  queryParams: PropTypes.object.isRequired,
  onDataChanged: PropTypes.func.isRequired,
  workOrderStatusesForSelect: PropTypes.arrayOf(PropTypes.object),
  hasShowAllServiceReportsInCustomerPortal: PropTypes.bool.isRequired
};

MassActions.defaultProps = {
  workOrderStatusesForSelect: []
};

export default MassActions;
